import React, { useState, useEffect, useRef } from 'react';
import Axios from 'axios';
import Helmet from 'react-helmet';

import ScrollHint from '../../components/ScrollHint';
import ScrollDiver from '../../components/ScrollDiver';

import './index.scss';
import Link from '../../components/Link';

const HomePage = ({ wording }) => {
  const theater = useRef(null);
  const [layers, setLayers] = useState(null);
  const [showSkip, setShowSkip] = useState(false);
  const showSkipRef = useRef();

  useEffect(() => {
    Axios.get(`/api/theater`).then(res => {
      const { content } = res.data;
      setLayers(JSON.parse(content));
    });


  }, [])

  const handleAtStart = () => {
    setShowSkip(false);
  };

  const handleAtMiddle = () => {
    setShowSkip(true);
  }

  const handleEnd = () => {
    setShowSkip(false);
  }


  const _w = wording;

  return (
    <React.Fragment>
      <Helmet>
        <title>{_w.meta_title}</title>
      </Helmet>
      <div className="home-page">
        <div className="theater" ref={theater}>
          {
            layers &&
            <ScrollDiver data={layers} distance={0.33} gap={0.2} startAt={2.5} custom={{ range: [123, 132] }} onAtStart={handleAtStart} onAtMiddle={handleAtMiddle} onEnd={handleEnd} />
          }
        </div>
        <ScrollHint className={`${showSkip ? "is--hidden" : ""}`} />

        <Link className={`skip-btn ${showSkip ? "is--show" : ""}`} to="/project" dangerouslySetInnerHTML={{ __html: _w.skip }} />
      </div>
    </React.Fragment>
  )
}

export default HomePage;